module.exports = __webpack_public_path__ + "fonts/Cramaten-2.b0a9c713.ttf";